import {Directive, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {trimObjectValues} from "@myshared/utils";
import {I18NextService} from "angular-i18next";

export type FormEmitter<T> = {
    data: T;
    formGroup: UntypedFormGroup;
}

@Directive()
export abstract class FormComponent<T> implements OnInit, OnChanges {
    public form: UntypedFormGroup;

    @Output() formSubmit = new EventEmitter<FormEmitter<T>>();
    @Output() formChange = new EventEmitter<FormEmitter<T>>();

    @Input() submitLabel: string = 'app_update';
    @Input() submitForm: boolean = true;

    constructor(protected fb: UntypedFormBuilder, protected i18next: I18NextService) {}

    ngOnInit() {
        this.createForm();
        this.subscribeValues();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.changeForm(changes);
    }

    public onSubmit() {
        if (this.form.invalid) return;
        this.emitSubmit();
    }

    public onInput() {
        this.emitChange();
    }

    public getValues() {
        return this.trimObject();
    }

    public formMapper(form: any): T  {
        return form as T;
    }
    protected onFormChanged(r: any) {}

    protected createForm() {};
    protected changeForm(changes?: SimpleChanges) {
        this.createForm();
        this.subscribeValues();
    };

    private emitSubmit() {
        this.formSubmit.emit(this.getFormData());
    }

    private emitChange() {
        this.formChange.emit(this.getFormData());
    }

    private getFormData() {
        return {
            data: this.formMapper(this.getValues()),
            formGroup: this.form,
        }
    }

    private trimObject(): any {
        return trimObjectValues(this.form.getRawValue());
    }

    // We need to re-subscribe, because we will override the form instance after a change (its a new form)
    private subscribeValues() {
        this.form?.valueChanges?.subscribe((r: any) =>  {
            this.onFormChanged(r)
            this.emitChange();
        })
    }
}
